// Body of the Oscar account-registration view: the toppers account-shell layout
// — the customer-service side nav, the "Sign Up" content title, and the
// ConvertLazyUserForm rendered as a native React field tree. The "CREATE
// ACCOUNT" submit label was a hardcoded literal in the template (not
// {% trans %}-wrapped, en-us only), so it is reproduced as a literal here; the
// page carries no brand heading or customer-service info block (page_copy /
// cs_info stay unused).
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import { duplicateEmailAfterField } from "tsi-common-react/src/forms/DuplicateEmailError/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { AccountShell } from "../AccountShell";

type IProps = Immutable<templates.RegistrationDocumentTemplate>;

export const RegistrationBody = (props: IProps): React.JSX.Element => (
    <AccountShell
        hasNav={props.has_nav}
        sideNav={props.side_nav}
        title={props.content_title}
        phoneDisplay={props.phone_display}
        phoneHref={props.phone_href}
    >
        <div className="login-standalone">
            <form
                className={concatClassNames([FORM_CLASS_NAME, "js-kuid-form"])}
                method="post"
                action={props.action_url}
            >
                <CSRFToken />
                <FormFields
                    fields={props.fields}
                    field_labels={props.field_labels}
                    field_errors={props.field_errors}
                    non_field_errors={props.non_field_errors}
                    afterField={duplicateEmailAfterField(props)}
                />
                <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                    <input
                        type="submit"
                        className="button button--full-width"
                        value="CREATE ACCOUNT"
                    />
                </div>
            </form>
        </div>
    </AccountShell>
);
